module.exports = __webpack_public_path__ + "static/media/СЗФО_96.0453dfb5.png";